module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "noindenttt",
    attrs: {
      "id": "fm01"
    }
  }, [_c('em', [_vm._v("Once upon a time there was a sleepy little town called Ferryport Landing. It was nestled on the banks of the Hudson River in upstate New York. Quaint little shops lined Main Street, and people spent days strolling along the town’s cobblestoned lanes and through its community gardens. Apple pies cooled on windowsills, and few people locked their doors at night. Some visitors thought Ferryport Landing had been plucked right out of a storybook.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("But that was a long time ago.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Now, the town was in ruins. Its death wasn’t slow, like so many tiny communities that decay and, eventually, disappear after the mill closes or the steel plant shuts its doors.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("No, Ferryport Landing was murdered—by its own citizens. They looted shops and smashed in windows. They overturned cars, leaving them scattered in the streets. They lit fires and watched hungry flames burn homes to the ground.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Sabrina and Daphne, the sisters Grimm, stood over its remains to pay their respects to a fallen friend.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("“Is that it?” Daphne asked. “Is that the end?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Sabrina nodded. “Yes. And it’s about time.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c0e686c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm01.vue
// module id = 66
// module chunks = 0